import React, {useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch, Router } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer';
import ReactModal from 'react-modal';
import moment from 'moment';
import Layout from './hoc/Layout/Layout';
import { Login } from './components';
import Page from './Page';
import { authService } from './services/auth-service';
import { history } from './helpers/history';
import { dashboardReset } from './redux/actions/dashboardAction';
import { SESSION_TIMEOUT } from './constants/localStorageConstants';

import './App.scss';

import CrossIcon from './assets/icons/cross.svg';

const App = () => {
  const [state, setState] = useState(false);
  const dispatch = useDispatch();
  const idle = 60 * 60 * 1000;

  useEffect(() => {
    const iconTitle = document.querySelector('link[rel="icon"]');
    const appTitle = document.getElementById('appTitle');
    appTitle.textContent = 'ONLINE ONE APP';
    iconTitle.href = 'ONLINE ONE APP';
  }, []);

  const onIdle = () => {
    if (authService.checkSession()) {
      dispatch(dashboardReset());
      authService.logout();
      handleOpenModalSessionEnd();
    }
  };

  const onMessage = (data) => {
    if (data === 'logout') {
      history.push('/');
      dispatch(dashboardReset());
    }
  };

  const onActive = () => {
    localStorage.setItem(SESSION_TIMEOUT, moment());
  };

  const { message } = useIdleTimer({
    onIdle,
    timeout: idle,
    crossTab: true,
    syncTimers: 500,
    onMessage,
    onActive,
  });

  const handleOpenModalSessionEnd = () => {
    setState(true);
  };

  const handleCloseModalSessionEnd = () => {
    setState(false);
  };

  React.useEffect(() => {
    let sessionTimeot = JSON.stringify(localStorage.getItem(SESSION_TIMEOUT));
    if (JSON.parse(sessionTimeot) !== null) {
      const diff = moment() - moment(JSON.parse(sessionTimeot));
      const rest = diff - idle;
      const seconds = Math.round(rest / 1000);

      if (seconds > 0) {
        dispatch(dashboardReset());
        authService.logout();
        handleOpenModalSessionEnd();
      }
    }
  }, [idle, dispatch]);

  return (
    <Router history={history}>
      <Layout>
        <div className="content-cover">
          <Switch>
            <Route path="/" exact render={(props) => <Login />} />
            <Route path="/" render={(props) => <Page message={message} />} />
          </Switch>
          <ReactModal
            isOpen={state}
            contentLabel="Modal"
            className="modal-container"
            overlayClassName="modal-overlay">
            <div className="modal-header">
              <h2>Сессия была прервана</h2>
              <button
                type="button"
                className="button-icontrigger modal-closetrigger"
                onClick={handleCloseModalSessionEnd}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
            <div className="modal-body">
              <p>
                Сессия была прервана в связи с бездействием на сайте более 60 минут. Чтобы
                продолжить, войдите в Личный кабинет
              </p>
            </div>
          </ReactModal>
        </div>
      </Layout>
    </Router>
  );
};

export default App;
